import {
  SpareAxleRequestFormSteps,
  SpareAxleRequestPossibleFormStepValues,
} from '~api/models/SpareAxleRequestCustomModels'
import actionCreatorFactory from 'typescript-fsa'
import { SendSpareAxleRequestRequest } from '@saf/saf-kundenportal-frontend-api/apis/SpareAxleRequestApi'
import { SpareAxleRequestForm } from '@saf/saf-kundenportal-frontend-api/models/SpareAxleRequestForm'
import { ErrorResponse } from '~api/models'
import { SpareAxleResponse } from '@saf/saf-kundenportal-frontend-api/models/SpareAxleResponse'

const actionCreator = actionCreatorFactory('SAR_WIZARD')

export type SpareAxleRequestFormAvailableSteps = SpareAxleRequestFormSteps | 'success'

export interface UpdateFormStepValuesProps {
  step: SpareAxleRequestFormSteps
  values: SpareAxleRequestPossibleFormStepValues
}

// Actions
export const setCurrentStep = actionCreator<SpareAxleRequestFormAvailableSteps>('SET_CURRENT_STEP')
export const resetForm = actionCreator<void>('RESET_FORM')
export const updateFormStepValues = actionCreator<UpdateFormStepValuesProps>('UPDATE_FORM_STEP_VALUES')
export const updateFormValues = actionCreator<SpareAxleRequestForm>('UPDATE_FORM_VALUES')
export const updateFormStepValuesAndSubmit = actionCreator<UpdateFormStepValuesProps>('UPDATE_FORM_STEP_VALUES_AND_SUBMIT')

export const submitForm = actionCreator.async<SendSpareAxleRequestRequest, SpareAxleResponse, ErrorResponse>('SUBMIT_FORM')
